<template>
  <div class="min-h-screen">
    <PageHeader
      title="Study Builder"
      subtitle="Regression-based causal analysis: What influences patient outcomes?"
      :breadcrumbs="[{ label: 'Insights' }, { label: 'Impact Analytics' }]"
    />
    <div class="p-6 pb-32">
      <StudyBuilder
        :attributes="attributes"
        :datasets="datasets"
        :frames="frames"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import StudyBuilder from './StudyBuilder.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';

export default {
  name: 'ImpactAnalytics',
  components: { PageHeader, StudyBuilder },
  data() {
    return {
      attributes: [],
      datasets: [],
      frames: [],
      loading: false,
    };
  },
  mounted() {
    this.fetchCatalog();
  },
  methods: {
    async fetchCatalog() {
      this.loading = true;
      try {
        const [attributes, datasets, frames] = await Promise.all([
          axios.get('api/impact_analytics/attributes/'),
          axios.get('api/impact_analytics/datasets/'),
          axios.get('api/impact_analytics/frames/'),
        ]);
        this.attributes = attributes.data;
        this.datasets = datasets.data;
        this.frames = frames.data;
      } catch (error) {
        console.error('Error fetching Impact Analytics catalog:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
